import Utilitiesjs from './utilites';
import Ajaxjs from './ajax';
import Tablesjs from './tables';
import regeneratorRuntime from "regenerator-runtime";

export default class CSCPTable {
    constructor() {
        let that = this;

        that.ajaxjs = new Ajaxjs;
        that.utilsjs = new Utilitiesjs;
        that.tablesjs = new Tablesjs;

        that.instance = "";
        that.additionalAttr = {};//Additional field properties
        that.maxPagination = 10;//Maximum number of pages to display
        that.localPageSize = 10;//Local page size

        that.url = `${window.location.protocol}//${window.location.host}`;//Local page size
        that.method = "";//The method to request data
        that.exportController = "";//The controller to export data 
        that.exportAction = "";//The action to export data 
        that.tableId = "";//The id of the current table
        that.baseData = [];//Initial Data
        that.currentPageData = [];//Data returned from the  server and changes after filtering

        that.columns = [
            { data: "", class: "" },
            { customContent: (row) => { }, class: "" }
        ]

        that.filterContainerEleId = "reportFilterForm";
        that.filter = {
            page: 1,
            pageSize: 50
        };//Page filtering parameters
    }

    //data displayed when the page first loads, 
    initTable(data, additionalAttr = {}) {
        let that = this;
        that.additionalAttr = additionalAttr;
        that.initSettings();

        const searchBtnEle = document.getElementById(that.searchBtnEleId);
        const exportBtnEle = document.getElementById(that.exportBtnEleId);

        if (searchBtnEle) {
            searchBtnEle.onclick = function () {
                if (that.exportAction === "/Members") {
                    that.filterData();
                } else {
                    that.setFilterParam();
                    that.search(1);
                }
            };
        }
        if (exportBtnEle) {
            exportBtnEle.onclick = function () {
                that.filterData();
                that.setFilterParam();//The exported filter condition is the current form value
                that.tablesjs.openUrlNewTab(that.exportAction, that.exportController, that.getFilterParamUrl());
            };
        }
        that.baseData = data;
        that.renderTableData(data);
    }

    //Initialize the table Settings
    initSettings() {

    }

    //Gets the current filter parameter and assigns it to the filter variable
    setFilterParam() {
        let that = this;
        const { trim } = this.utilsjs;

        const filterObject = that.getFilterObject();

        that.filter = {
            page: 1,
            pageSize: 50
        };//Page filtering parameters
        that.filter = { ...that.filter, ...filterObject };
    }

    //Gets the url link composed of the current filter parameters
    getFilterParamUrl() {
        const { filter } = this;
        const paramUrl = Object.keys(filter).map(key => {
            const value = filter[key];

            if (Array.isArray(value)) {
                return value.map(v => `${key}=${encodeURIComponent(v)}`).join("&")
            }
            else {
                return `${key}=${encodeURIComponent(value)}`;
            }
        })
        return "?" + paramUrl.join("&");
    }

    //filter data using only existing data
    filterData() {
        const that = this;
        const filterObject = that.getFilterObject();
        const data = {
            CurrentPageNumber: 0, RecordOffset: 0, Records: {}, TotalPageCount: 0, TotalRecords: 0, TotalTopLevelRecords: 0 };
        const checks = [];

        Object.keys(filterObject).map(key => {
            const value = filterObject[key];
            if (Array.isArray(value)) {
                value.map(v => checks.push(v));
            }
        })

        data.Records = that.baseData.Records.filter(function (el) {
            if (checks.length == 0) return true;
            let result = true;
            Object.keys(checks).map(key => {
                if (checks[key] === "1" || checks[key] === "2") {
                    if (el.Cycle !== checks[key]) result = false;
                } else if (checks[key] === "NotPaid") {
                    if (el["Paid"] !== false) result = false;
                } else if (checks[key] === "ReadyforAuditNo") {
                    if (el["ReadyforAudit"] !== false) result = false;
                } else if (checks[key] === "AuditedNo") {
                    if (el["Audited"] !== false) result = false;
                }else if (checks[key] === "ReadyforAuditYes") {
                    if (el["ReadyforAudit"] !== true) result = false;
                } else if (checks[key] === "AuditedYes") {
                    if (el["Audited"] !== true) result = false;
                }else {
                    if (el[checks[key]] !== true)  result = false;
                }

            })
            return result;
        });

        that.renderTableData(data)
    }

    //Perform data filtering (Local||Server)
    async search(page = 1) {
        const that = this;

        if (that.needReloadData()) {
            page = 1;
        }
        that.setFilterParam();
        that.filter.page = page;

        let url = `${that.url}${that.method}` + that.getFilterParamUrl();

        const response = await fetch(url);
        const result = await response.json();

        if (!result) {
            return;
        }
        that.renderTableData(result)
    }


    renderTableData(data) {
        const that = this;
        that.currentPageData = data.Records;
        that.renderList(data.Records);
        that.renderPagination(data.CurrentPageNumber, data.TotalPageCount, "search", "tablePagination", true);
    }

    renderList(data) {
        const that = this;

        let arrHtml = [];

        if (data) {
            arrHtml = data.map(row => {
                const trContent = that.columns.map(column => {
                    if (column.customContent) {
                        return `<td class="${column.class}">${column.customContent(row)}</td>`;
                    } else {
                        let text = row[column.data];
                        text = text === null || text === undefined ? "" : text;
                        return `<td class="${column.class}">${text}</td>`;
                    }
                });
                return `<tr>${trContent.join("")}</tr>`;
            })
        }
        document.querySelector(`#${that.tableId} tbody`).innerHTML = arrHtml.join("");
        window.scrollTo(0, 0);
    }

    renderPagination(currentPage, totalPage, clickEvent, containerEleId, isServer) {
        const that = this;

        let paginationHtml = "";

        if (totalPage > 0) {
            const maxPagination = that.maxPagination;

            let paginations = [];
            const startPagination = that.getStartPagination(currentPage, maxPagination, totalPage);
            const endPagination = startPagination + maxPagination - 1;

            clickEvent = that.instance + "." + clickEvent;

            if (isServer) {
                for (let i = startPagination; i <= endPagination && i <= totalPage; i++) {
                    let j = i === 1 ? 1 : ((i - 1) * 50) + 1;
                    paginations.push(
                        `<li class="${i === currentPage ? "active" : ""}" data-page="${i}">
                    <a ${i !== currentPage ? "onclick=\"" + clickEvent + "(" + i + ")\"" : ""}><i>${j}-${j + 49}</i></a>
                </li>`
                    );
                }
            } else {
                for (let i = startPagination; i <= endPagination && i <= totalPage; i++) {
                    paginations.push(
                        `<li class="${i === currentPage ? "active" : ""}" data-page="${i}">
                    <a ${i !== currentPage ? "onclick=\"" + clickEvent + "(" + i + ")\"" : ""}><i>${i}</i></a>
                </li>`
                    );
                }
            }


            paginationHtml = `
                <li>
                    <a  ${currentPage !== startPagination ? "onclick=\"" + clickEvent + "(" + (currentPage - 1) + ")\"" : "style=\"display:none\""}>
                        <i><</i>
                    </a>
                </li>
                ${paginations.join("")}
                <li>
                    <a ${totalPage !== currentPage ? "onclick=\"" + clickEvent + "(" + (currentPage + 1) + ")\"" : "style=\"display:none\""}>
                        <i>></i>
                    </a>
                </li>`;
        }

        document.getElementById(containerEleId).innerHTML = paginationHtml;

    }
    getStartPagination(currentPage, maxPagination, totalPage) {
        let startPagination = currentPage - maxPagination / 2;
        startPagination = startPagination <= 0 ? 1 : startPagination;

        if (totalPage - startPagination < maxPagination - 1) {
            startPagination = totalPage - maxPagination + 1;
        }

        startPagination = startPagination <= 0 ? 1 : startPagination;
        return startPagination;
    }

    // If the filter condition changes, click on the page number and reload the data from the first page
    needReloadData() {
        const that = this;
        const { filter } = that;
        const { trim } = that.utilsjs;

        let currentFilter = that.getFilterObject(true);

        const filterKeys = Object.keys(currentFilter);

        for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i];
            if ((filter[key] || "").toString() !== (currentFilter[key] || "").toString()) {
                return true;
            }
        }
        return false;
    }

    //Custom filter conditions
    customLocalFilter(item) {
        return true;
    }

    getFilterObject(ignoreHiddenEle = false) {
        const that = this;
        const { trim } = that.utilsjs;
        let ckName = "";
        let filterObject = {};
        document.querySelectorAll(`#${that.filterContainerEleId} input,#${that.filterContainerEleId} select`).forEach(ele => {

            if (ignoreHiddenEle && ele.hidden) {
                return;
            }

            const { value, name, type } = ele;
            if (type === "checkbox") {
                if (ele.checked === true) {
                    if (ckName === name) {
                        filterObject[name].push(value);
                    } else {
                        ckName = name;
                        filterObject[name] = [value];
                    }
                } else {
                    if (ckName !== name) {
                        filterObject[name] = [];//default value
                    } else {
                        ckName = name;
                    }
                }
            } else if (type === "select-one") {
                if (value !== "") {
                    if (ckName === value) {
                        filterObject[value].push(value);
                    } else {
                        ckName = value;
                        filterObject[value] = [value];
                    }
                } else {
                    if (ckName !== value) {
                        filterObject[value] = [];//default value
                    } else {
                        ckName = value;
                    }
                }
            } else {
                filterObject[name] = trim(value);
            }
        })

        return filterObject;
    }
}





// WEBPACK FOOTER //
// ./Scripts/es6/cscp-table.js